import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgIn = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F93",
      fillRule: "evenodd",
      d: "M23.622 9H.378C1.71 3.824 6.408 0 12 0s10.29 3.824 11.622 9",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M23.622 15c.247-.959.378-1.964.378-3s-.131-2.041-.378-3H.378A12 12 0 0 0 0 12c0 1.036.131 2.041.378 3z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#128807",
      fillRule: "evenodd",
      d: "M23.622 15c-1.332 5.176-6.03 9-11.622 9C6.41 24 1.71 20.176.378 15z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#008",
      d: "M12 14.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M12 14.1a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#008",
      d: "M12 12.42a.42.42 0 1 0 0-.84.42.42 0 0 0 0 .84"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#008",
      fillRule: "evenodd",
      d: "M11.834 9.904a.108.108 0 1 0-.214.028.108.108 0 0 0 .214-.028m.094 1.256L12 9.9l.072 1.26-.072.6zm-.215.047-.256-1.235.395 1.198.086.598-.225-.56Zm-.195.101-.568-1.127.692 1.056.238.555-.362-.483Zm-.163.149-.84-.942.942.84.373.475zm-.119.185-1.055-.692 1.127.568.484.362zm-.066.21-1.198-.396 1.235.257.561.225zm-.01.22L9.9 12l1.26-.072.6.072zm.047.215-1.236.257 1.199-.396.598-.086zm.101.195-1.127.568 1.055-.692.556-.238zm2.881-.193a.108.108 0 1 1-.214-.028.108.108 0 0 1 .214.028m-2.117.551L12 14.1l-.072-1.26.072-.6zm1.91-.135a.108.108 0 1 0-.083.199.108.108 0 0 0 .082-.2Zm-2.13.125-.396 1.198.257-1.235.225-.561zm1.748.535a.108.108 0 1 0 .131-.172.108.108 0 0 0-.131.172m-1.958-.601-.692 1.055.568-1.128.362-.483zm1.55.968a.108.108 0 1 0 .172-.131.108.108 0 0 0-.172.131m-1.735-1.087-.942.84.84-.942.475-.373zm1.246 1.337a.108.108 0 1 0 .2-.083.108.108 0 0 0-.2.083m-.537.114a.108.108 0 1 0 .214-.028.108.108 0 0 0-.214.028m-.548-.028a.108.108 0 1 0 .214.028.108.108 0 0 0-.214-.028m-.522-.17a.108.108 0 1 0 .2.083.108.108 0 0 0-.2-.082Zm-.46-.298a.108.108 0 1 0 .17.131.108.108 0 0 0-.17-.131m-.368-.408a.108.108 0 1 0 .131.172.108.108 0 0 0-.131-.172m-.25-.489a.108.108 0 1 0 .083.2.108.108 0 0 0-.083-.2m-.114-.537a.108.108 0 1 0 .028.214.108.108 0 0 0-.028-.214m.028-.548a.108.108 0 1 0-.028.214.108.108 0 0 0 .028-.214m.17-.522a.108.108 0 1 0-.083.2.108.108 0 0 0 .082-.2Zm2.046.074.395-1.198-.256 1.235-.225.561zm-1.748-.535a.108.108 0 1 0-.131.172.108.108 0 0 0 .131-.172m1.958.602.692-1.056-.568 1.128-.362.483zm-1.55-.97a.108.108 0 1 0-.171.132.108.108 0 0 0 .17-.131Zm1.735 1.088.942-.84-.84.942-.475.373zm-1.246-1.337a.108.108 0 1 0-.2.083.108.108 0 0 0 .2-.083m1.394 1.5 1.128-.568-1.056.692-.555.238zm.102.195 1.235-.256-1.198.395-.598.086.56-.225Zm-.411-1.78a.108.108 0 1 0-.215-.029.108.108 0 0 0 .215.028Zm.458 1.995L14.1 12l-1.26.072-.6-.072zm.064-1.827a.108.108 0 1 0-.2-.082.108.108 0 0 0 .2.082m-.074 2.047 1.198.396-1.235-.257-.561-.225zm.535-1.748a.108.108 0 1 0-.172-.131.108.108 0 0 0 .172.131m-.602 1.958 1.056.692-1.128-.568-.483-.362zm.97-1.55a.108.108 0 1 0-.132-.171.108.108 0 0 0 .131.17Zm-1.088 1.735.84.942-.942-.84-.373-.475zm1.337-1.246a.108.108 0 1 0-.083-.2.108.108 0 0 0 .083.2m-1.5 1.394.568 1.128-.692-1.056-.238-.555zm1.614-.857a.108.108 0 1 0-.028-.214.108.108 0 0 0 .028.214m-1.81.959.257 1.236-.395-1.199-.086-.598z",
      clipRule: "evenodd"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgIn;